import React from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const Atras = () => {
  const navigate = useNavigate();

  return (
    <IconButton
      onClick={() => navigate(-1)}
      sx={{
        color: "rgba(255,255,255,0.75)",
        background: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: "12px",
        mr: 1,
        flexShrink: 0,
        "&:hover": {
          background: "rgba(0,212,255,0.1)",
          borderColor: "rgba(0,212,255,0.35)",
          color: "#00d4ff",
        },
        transition: "all 0.2s ease",
      }}
    >
      <ArrowBackIcon />
    </IconButton>
  );
};

export default Atras;

